import { gql } from '@apollo/client';
import * as Types from '../../../../types/api.types.generated.d';

import { JobOrderApplicationFragmentFragmentDoc } from './jobOrderApplication.fragment.generated';

export type JobOrderFragmentFragment = {
  __typename?: 'JobOrderHubType';
  jobOrderId: string;
  customId: number;
  jobOrderLabel: string;
  clientName?: string | null;
  seniority?: Types.SeniorityLevelEnum | null;
  experienceYears?: number | null;
  description?: string | null;
  dateStart1?: any | null;
  dateStart2?: any | null;
  dateEnd?: any | null;
  locationPreference?: string | null;
  minEnglishLevel?: Types.LanguageLevelEnum | null;
  workMode?: Types.WorkModeEnum | null;
  rateRangeTo?: number | null;
  rateRangeFrom?: number | null;
  isEnglish?: boolean | null;
  maxAvailability?: Types.MaxAvailabilityEnum | null;
  createdAt: any;
  assignmentDate?: any | null;
  isChubVisible: boolean;
  leadingTechnology?: string | null;
  isJobPositionStrictlyRequired: boolean;
  isSaved?: boolean | null;
  isAIRAvailable: boolean;
  isOnlyAir: boolean;
  skillsMustHave: Array<{ __typename?: 'ExpertTagType'; id: string; name: string; weight: number }>;
  skillsNiceToHave: Array<{ __typename?: 'ExpertTagType'; id: string; name: string }>;
  owner?: { __typename?: 'UserHubType'; email: string; name: string } | null;
  assignees: Array<{
    __typename?: 'JobOrderAssigneesParamsType';
    brm?: string | null;
    talentAdvocates?: Array<string> | null;
  }>;
  application?: {
    __typename?: 'JobOrderApplicationHubType';
    applicationId: string;
    jobOrderId: string;
    publicOfferId?: string | null;
    createdAt: string;
    meetingDates: Array<string>;
    ciDate?: string | null;
    cqDate?: string | null;
    status: Types.JobOrderApplicationStatusEnum;
    processStatus: Types.JobOrderApplicationProcessStatusEnum;
    prevProcessStatus?: Types.JobOrderApplicationProcessStatusEnum | null;
    meetingUrl?: string | null;
    isViewedByExpert: boolean;
    handlerId?: string | null;
    preppingId?: string | null;
    flow?: Types.JobOrderApplicationFlowEnum | null;
    contactByPhone?: boolean | null;
    isPreferencesFinished: boolean;
    hasActiveAirInterviewInvitation: boolean;
    preferences?: {
      __typename?: 'JobOrderApplicationPreferencesType';
      location?: string | null;
      workType?: Types.WorkModeEnum | null;
      rateDesired?: number | null;
      linkedInUrl?: string | null;
      availability?: Types.ExpertAvailabilityEnum | null;
      noticeLength?: number | null;
      experienceYears?: number | null;
      englishLevel?: Types.LanguageLevelEnum | null;
      skillsMustHave?: Array<{
        __typename?: 'PreferencesSkillType';
        tagId: string;
        weight: number;
      }> | null;
      skillsNiceToHave?: Array<{
        __typename?: 'PreferencesSkillType';
        tagId: string;
        weight: number;
      }> | null;
    } | null;
  } | null;
};

export const JobOrderFragmentFragmentDoc = gql`
  fragment JobOrderFragment on JobOrderHubType {
    jobOrderId
    customId
    jobOrderLabel
    clientName
    skillsMustHave {
      id
      name
      weight
    }
    skillsNiceToHave {
      id
      name
    }
    seniority
    experienceYears
    description
    dateStart1
    dateStart2
    dateEnd
    locationPreference
    minEnglishLevel
    workMode
    rateRangeTo
    rateRangeFrom
    isEnglish
    maxAvailability
    owner {
      email
      name
    }
    assignees {
      brm
      talentAdvocates
    }
    createdAt
    assignmentDate
    dateEnd
    isChubVisible
    application {
      ...JobOrderApplicationFragment
    }
    leadingTechnology
    isJobPositionStrictlyRequired
    isSaved
    isAIRAvailable
    isOnlyAir
  }
  ${JobOrderApplicationFragmentFragmentDoc}
`;
